import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9988e7ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  style: {"cursor":"pointer","display":"block"}
}
const _hoisted_2 = {
  key: 1,
  style: {"display":"block"}
}

import { ref, unref, reactive, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import { useAppStore } from '@/store/app';
import {GetWorkTimeLineApi, InvolvedUserList, saveInvolvedUserList} from '@/apis/tasks/task.api';
import { AuditUrgeApi } from '@/apis/contract/contract.api';
import moment from 'moment';
import {useUser} from "@/store/user.store";
import {RelateContractApi} from "@/apis/contract/draft.api";
import { useLocales } from '@/hooks/useLocales';


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const { t } = useLocales();
const login = useAppStore().getLoginInfo;
const userStore = useUser();
const state = reactive({
  maxId: 0,
  currentRow:{} as any,
  show: false,
  loading: false,
  urgeLoad: false,
  contractId: '',
  createUserId: '',
  workList: [] as any[],
  dataList: [] as any[],
  userList: [] as any[],
  ctId: ''
});

const load = {

};


/* 公开的方法 */
const methods = {
  showDrawer2: (ctId: string) => {
    state.loading = true;
    state.ctId = ctId;
    InvolvedUserList(ctId)
    .then((res) => {
      console.log('',res)
      state.dataList = res.data
      state.maxId = res.data.length-1
      console.log('dtt',state.dataList)
      console.log('maxindex',state.maxId)
    })
    state.show = true;
  },
};

const typeOptions = [
  { value: '查看者', label: t('contracts.viewer', '查看者') },
  { value: '补充信息', label: t('contracts.supplementInfo', '补充信息') }
]

const addInvolved = () => {
  let view = {
    id:++state.maxId,
    user_id: '',
    node_name: '查看者',
    create_user_name : login.user_name +'('+login.user_account+')',
    create_user_id : login.user_account
  }
  state.dataList.push(view);
}

const handleChange = (row:any) => {
  console.log('row哈哈',row,state.dataList)
  let obj = state.dataList.find(item => item.user_id === row.user_id && item.user_name?.trim().length >0)
  if(obj){
    ElMessage.warning(t('contracts.existsUser', '已存在该人员!'))
    row.user_id = ''
    row.user_name = ''
    return
  }else {
    let ct = state.userList.find(item => item.value === row.user_id)
    if(ct){
      row.user_name = ct.label
    }
  }
}

const delViewer = (row:any) => {
  for (let i = 0; i < state.dataList.length; i++) {
    if (row.id == state.dataList[i].id) {
      state.dataList.splice(i, 1);
    }
  }
}

const saveData = () => {
  state.dataList.some(item => {
    if (!(item.user_name?.trim().length > 0)) {
      ElMessage.error(t('contracts.fillTableInfo', '请完善填表格信息'));
      return true; // 返回 true 以中断 some() 循环
    }
    return false; // 继续循环
  });
  let data = {
    ct_id:state.ctId,
    accesslist: state.dataList
  }
  saveInvolvedUserList(data).then((res) => {
     console.log(res)
    if(res.succeeded){
      ElMessage.success(t('contracts.saveSuccess', '操作成功'))
    }
  })
}


const handleCurrentChange = (val:any) =>{
  state.currentRow = val;
}

expose({ ...methods });

onMounted( () => {
 // const {succeeded, errors, data} = await RelateContractApi();
  state.userList = userStore.getSelectList();
  console.log('use', state.userList)
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: _unref(state).show,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).show) = $event)),
    title: _unref(t)('contracts.involvedUsersTitle', '参与人员')
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              icon: "Plus",
              onClick: addInvolved,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('contracts.addInvolved', '增加参与人')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              icon: "Check",
              onClick: saveData,
              type: "success"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('contracts.saveSuccess', '保存')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_table, {
          data: _unref(state).dataList,
          border: true,
          width: "100%",
          size: "small",
          "header-cell-style": {background:'#ecf5ff'},
          style: {"margin-top":"20px"},
          onCurrentChange: handleCurrentChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: _unref(t)('contracts.operation', '操作'),
              "min-width": "60"
            }, {
              default: _withCtx((scope) => [
                (['查看者','补充信息'].includes(scope.row.node_name) && scope.row.create_user_id === _unref(login).user_account)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      icon: "Delete",
                      size: "small",
                      text: "",
                      type: "primary",
                      onClick: ($event: any) => (delViewer(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('contracts.delete', '删除')), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              type: "index",
              label: _unref(t)('contracts.sequence', '序号'),
              width: "60",
              align: 'center'
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "user_name",
              label: _unref(t)('contracts.participant', '参与人')
            }, {
              default: _withCtx((scope) => [
                (_unref(state).currentRow?.id === scope.row.id && ['查看者','补充信息'].includes(scope.row.node_name))
                  ? (_openBlock(), _createBlock(_component_el_select, {
                      key: 0,
                      clearable: "",
                      modelValue: scope.row.user_id,
                      "onUpdate:modelValue": ($event: any) => ((scope.row.user_id) = $event),
                      filterable: "",
                      onChange: ($event: any) => (handleChange(scope.row))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).userList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(scope.row.user_name ?? '-'), 1))
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "node_name",
              label: _unref(t)('contracts.participantNode', '参与节点')
            }, {
              default: _withCtx((scope) => [
                (_unref(state).currentRow?.id === scope.row.id && ['查看者','补充信息'].includes(scope.row.node_name))
                  ? (_openBlock(), _createBlock(_component_el_select, {
                      key: 0,
                      modelValue: scope.row.node_name,
                      "onUpdate:modelValue": ($event: any) => ((scope.row.node_name) = $event)
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(typeOptions, (item) => {
                          return _createVNode(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"])
                        }), 64))
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(scope.row.node_name ?? '-'), 1))
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "create_user_name",
              label: _unref(t)('contracts.authorizer', '授权者')
            }, null, 8, ["label"])
          ]),
          _: 1
        }, 8, ["data"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})